import React, { ReactElement } from "react";

import LoadingSpinner from "components/LoadingSpinner";
import classNames from "shared/utils/classNames";

interface SubmitButtonProps {
  isSubmitting?: boolean;
  className?: string;
  children?: string | ReactElement;
  disabled?: boolean;
  onClick?: () => void;
}

const SubmitButton: React.FC<SubmitButtonProps> = ({
  isSubmitting = false,
  className = "",
  children = "Submit",
  disabled = false,
  onClick,
}) => {
  return (
    <button
      className={classNames("btn-primary rounded-3xl", className)}
      type="submit"
      onClick={onClick}
      disabled={disabled || isSubmitting}
    >
      {isSubmitting && (
        <div className="relative h-5 w-5 border-white">
          <LoadingSpinner />
        </div>
      )}
      {children}
    </button>
  );
};

export default SubmitButton;
